import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface TransmissionProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function Transmission(props: TransmissionProps) {
  return (
    <svg
      width="130"
      height="98"
      viewBox="0 0 130 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 202, left: 281}}
      onClick={props.onClick}
    >
      <path
        d="M1 97V49V1H29C37 1 37 5 37 5V9H61C65 9 65 13 65 13H94C97 13 96 16 98 18C101.066 21.0659 129 29 129 29V49V69C129 69 101.066 76.9341 98 80C96 82 97 85 94 85H65C65 85 65 89 61 89H37V93C37 93 37 97 29 97H1Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M1 97V49V1H29C37 1 37 5 37 5V9H61C65 9 65 13 65 13H94C97 13 96 16 98 18C101.066 21.0659 129 29 129 29V49V69C129 69 101.066 76.9341 98 80C96 82 97 85 94 85H65C65 85 65 89 61 89H37V93C37 93 37 97 29 97H1Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M37.0001 9V89"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M29.0001 1V97"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M65.0001 13V85"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        opacity="0.1"
        d="M69 21C69 19.8954 68.1046 19 67 19H65V23H67C68.1046 23 69 22.1046 69 21Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        opacity="0.1"
        d="M55 21C55 19.8954 55.8954 19 57 19H65V23H57C55.8954 23 55 22.1046 55 21Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M89.0001 13V85"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path d="M94 13V85" stroke="currentColor" className={partStroke({variant: props.variant})} />
      <path
        d="M1.00009 49H55"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M69 49L129 49"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M37 28L125 28"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M37.2681 70C71.5295 70 90.7385 70 125 70"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1.00009 57H29.0001M1.00009 41H29.0001"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M57 23H65V19H57C57 19 55 19 55 21C55 23 57 23 57 23Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M121 33H129V29H121C121 29 119 29 119 31C119 33 121 33 121 33Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M121 45H129V41H121C121 41 119 41 119 43C119 45 121 45 121 45Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M121 57H129V53H121C121 53 119 53 119 55C119 57 121 57 121 57Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M121 69H129V65H121C121 65 119 65 119 67C119 69 121 69 121 69Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M67 23H65V19H67C67 19 69 19 69 21C69 23 67 23 67 23Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M67 37H65V33H67C67 33 69 33 69 35C69 37 67 37 67 37Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M67 51H65V47H67C67 47 69 47 69 49C69 51 67 51 67 51Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M67 65H65V61H67C67 61 69 61 69 63C69 65 67 65 67 65Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M67 79H65V75H67C67 75 69 75 69 77C69 79 67 79 67 79Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M57 37H65V33H57C57 33 55 33 55 35C55 37 57 37 57 37Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M57 51H65V47H57C57 47 55 47 55 49C55 51 57 51 57 51Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M57 65H65V61H57C57 61 55 61 55 63C55 65 57 65 57 65Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M57 79H65V75H57C57 75 55 75 55 77C55 79 57 79 57 79Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
